import React from "react";

const PaymentsIcon = ({ color = "#5D5D5D" }) => {
  return (
    <svg
      width="16"
      height="13"
      viewBox="0 0 16 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.3334 1.625V11.375C15.3334 11.675 15.2234 11.9375 15.0034 12.1625C14.7834 12.3875 14.5267 12.5 14.2334 12.5H1.76675C1.47341 12.5 1.21675 12.3875 0.996748 12.1625C0.776748 11.9375 0.666748 11.675 0.666748 11.375V1.625C0.666748 1.325 0.776748 1.0625 0.996748 0.8375C1.21675 0.6125 1.47341 0.5 1.76675 0.5H14.2334C14.5267 0.5 14.7834 0.6125 15.0034 0.8375C15.2234 1.0625 15.3334 1.325 15.3334 1.625ZM1.76675 3.66875H14.2334V1.625H1.76675V3.66875ZM1.76675 6.0875V11.375H14.2334V6.0875H1.76675Z"
        fill={color}
      />
    </svg>
  );
};

export default PaymentsIcon;
